import { events, track } from 'src/analytics';

import type { SubscriptionType } from 'src/graphql/types';

export function trackToggleProductLineClick(productLine: SubscriptionType) {
  track(events.toggle_product_line_click, {
    productLine,
  });
}
